import * as React from 'react';
import { useUser } from '@clerk/react';

export const AccountStatus = () => {
    const { user } = useUser();
    if (!user) return null;

    const metadata = user.publicMetadata as { stripeSubscriptionStatus?: string, trialExpiresAt?: number };
    const isSubscribed = metadata.stripeSubscriptionStatus === 'active';
    const trialDaysLeft = metadata.trialExpiresAt ? Math.max(0, Math.ceil((metadata.trialExpiresAt - Date.now()) / (1000 * 60 * 60 * 24))) : 0;

    let statusText = "";
    let colorClass = "";

    if (isSubscribed) {
        statusText = "PRO SUBSCRIPTION ACTIVE";
        colorClass = "bg-emerald-500/10 text-emerald-500 border-emerald-500/20";
    } else if (trialDaysLeft > 0) {
        statusText = "TRIAL ACTIVE: " + trialDaysLeft + " DAYS REMAINING";
        colorClass = "bg-blue-500/10 text-blue-500 border-blue-500/20";
    } else {
        statusText = "LICENSE EXPIRED (ONE-OFF REPORT MODE)";
        colorClass = "bg-orange-500/10 text-orange-500 border-orange-500/20";
    }

    return (
        <div className={"px-6 py-3 rounded-2xl border flex items-center justify-between font-black text-[10px] tracking-[0.2em] uppercase " + colorClass}>
            <span className="flex items-center gap-2">
                <div className={"w-2 h-2 rounded-full animate-pulse " + (isSubscribed || trialDaysLeft > 0 ? 'bg-emerald-500' : 'bg-orange-500')} />
                {statusText}
            </span>
            {!isSubscribed && (
                <a href={"https://cadops.com.au/paywall"} className="hover:underline opacity-60 hover:opacity-100 transition-opacity">Upgrade Account</a>
            )}
        </div>
    );
};
